<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header class="pb-0">
      <b-card-title>{{ $t('stats') }}</b-card-title>
      <!-- <b-card-text class="mr-25 mb-0">
        Updated 1 month ago
      </b-card-text> -->
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row class="justify-content-between">
        <b-col
          v-for="item in statisticsItems"
          :key="item.subtitle"
          md="auto"
          sm="6"
          class="mb-2 mb-md-0"
          :class="item.customClass"
        >
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar
                size="48"
                :variant="item.color"
              >
                <feather-icon
                  size="24"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  components: {},

  props: {
    statisticsItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    }
  },
}
</script>
